const TreasurerDashboard = () => import("@/pages/TreasurerDashboard.vue");
const AccountsIndex = () => import("@/pages/AccountsIndex.vue");
const AccountOverview = () => import("@/pages/AccountOverview.vue");
const AccountDetails = () => import("@/pages/AccountDetails.vue");
const AccountRecurring = () => import("@/pages/AccountRecurring.vue");
const AccountDonationPageOptions = () => import("@/pages/AccountDonationPageOptions.vue");
const AccountDonationPageDesign = () => import("@/pages/AccountDonationPageDesign.vue");
const AccountUsers = () => import("@/pages/AccountUsers.vue");
const AccountDownloads = () => import("@/pages/AccountDownloads.vue");
const AccountBankInfo = () => import("@/pages/AccountBankInfo.vue");
const AccountCompliance = () => import("@/pages/AccountCompliance.vue");
const AccountBatching = () => import("@/pages/AccountBatching.vue");
const AccountIntegrations = () => import("@/pages/AccountIntegrations.vue");
const AccountViewCampaigns = () => import("@/pages/AccountViewCampaigns.vue");
const AccountViewEvents = () => import("@/pages/AccountViewEvents.vue");
const AccountViewMerchandise = () => import("@/pages/AccountViewMerchandise.vue");
const AccountViewMerchandiseEdit = () => import("@/pages/AccountViewMerchandiseEdit.vue");
const AccountViewMerchandiseSettings = () => import("@/pages/AccountViewMerchandiseSettings.vue");
const AccountEditEvents = () => import("@/pages/AccountEditEvents.vue");
const AccountCreateEvents = () => import("@/pages/AccountCreateEvents.vue");
const AccountImportsBulk = () => import("@/pages/AccountImportsBulk.vue");
const AccountEMailingList = () => import("@/pages/AccountEMailingList.vue");
const SearchResults = () => import("@/pages/SearchResults.vue");
const LoginComplete = () => import("@/pages/LoginComplete.vue");
const EinConfirmationLetterExample = () => import("@/pages/EinConfirmationLetterExample.vue");
const NewAccountWizard = () => import("@/pages/NewAccountWizard.vue");
const GetStarted = () => import("@/pages/GetStarted.vue");
const SuperAdminDashboard = () => import("@/pages/SuperAdminDashboard.vue");
const SuperAdminExports = () => import("@/pages/SuperAdminExports.vue");
const SuperAdminInvoices = () => import("@/pages/SuperAdminInvoices.vue");
const SuperAdminAttempts = () => import("@/pages/SuperAdminAttempts.vue");
const SuperAdminApplications = () => import("@/pages/SuperAdminApplications.vue");
const SuperAdminNotifications = () => import("@/pages/SuperAdminNotifications.vue");
const ProfileSettings = () => import("@/pages/ProfileSettings.vue");
const SuperAdminUsers = () => import("@/pages/SuperAdminUsers.vue");
const SuperAdminClients = () => import("@/pages/SuperAdminClients.vue");

const Logout = () => import("@/pages/Logout.vue");
const NotFound = () => import("@/pages/NotFound.vue");

const siteName = "eFund Connect";

export default {
	mode: "history",
	routes: [
		{
			path: "/v/NewAccountWizard",
			name: "NewAccountWizard",
			component: NewAccountWizard,
			meta: { title: `New Account | ${siteName}` },
		},
		{
			path: "/v/get-started",
			name: "GetStarted",
			component: GetStarted,
			meta: {
				title: `Get Started | ${siteName}`,
				isForLoggedOutUsers: true
			},
		},
		{
			path: "/v/",
			name: "TreasurerDashboard",
			component: TreasurerDashboard,
			meta: { title: `Dashboard | ${siteName}` },
		},
		{
			path: "/v/settings",
			name: "ProfileSettings",
			component: ProfileSettings,
			meta: { title: `Profile Settings | ${siteName}` },
		},
		{
			path: "/v/login/complete",
			name: "LoginComplete",
			component: LoginComplete,
			meta: {
				title: `Redirecting | ${siteName}`,
				isForLoggedOutUsers: true
			},
		},
		{
			path: "/v/account",
			name: "AccountsIndex",
			component: AccountsIndex,
			meta: { title: `Accounts | ${siteName}` },
		},
		{
			path: "/v/account/:id",
			name: "AccountOverview",
			component: AccountOverview,
			meta: { title: `Account Overview | ${siteName}` },
		},
		{
			path: "/v/account/:id/details",
			name: "AccountDetails",
			component: AccountDetails,
			meta: { title: `Account Details | ${siteName}` },
		},
		{
			path: "/v/account/:id/donation-page",
			name: "DonationPageOptions",
			component: AccountDonationPageOptions,
			meta: { title: `Donation Page | ${siteName}` },
		},
		{
			path: "/v/account/:id/compliance",
			name: "AccountCompliance",
			component: AccountCompliance,
			meta: { title: `Compliance | ${siteName}` },
		},
		{
			path: "/v/account/:id/recurring",
			name: "AccountRecurring",
			component: AccountRecurring,
			meta: { title: `Recurring Contributions | ${siteName}` },
		},
		{
			path: "/v/account/:id/users",
			name: "AccountUsers",
			component: AccountUsers,
			meta: { title: `User Management | ${siteName}` },
		},
		{
			path: "/v/account/:id/reports",
			name: "AccountDownloads",
			component: AccountDownloads,
			meta: { title: `Exports/Reports/Invoices | ${siteName}` },
		},
		{
			path: "/v/account/:id/banking",
			name: "AccountBankInfo",
			component: AccountBankInfo,
			meta: { title: `Bank Information | ${siteName}` },
		},
		{
			path: "/v/account/:id/disbursements",
			name: "AccountBatching",
			component: AccountBatching,
			meta: { title: `Disbursements | ${siteName}` },
		},
		{
			path: "/v/account/:id/integrations",
			name: "AccountIntegrations",
			component: AccountIntegrations,
			meta: { title: `Integrations | ${siteName}` },
		},
		{
			path: "/v/account/:id/campaigns",
			name: "AccountViewCampaigns",
			component: AccountViewCampaigns,
			meta: { title: `Campaigns | ${siteName}` },
		},
		{
			path: "/v/account/:id/events",
			name: "AccountViewEvents",
			component: AccountViewEvents,
			meta: { title: `Events | ${siteName}` },
		},
		{
			path: "/v/account/:id/Events/Edit",
			name: "AccountEditEvents",
			component: AccountEditEvents,
			meta: { title: `Edit Event | ${siteName}` },
		},
		{
			path: "/v/account/:id/Events/Create",
			name: "AccountCreateEvents",
			component: AccountCreateEvents,
			meta: { title: `Create Event | ${siteName}` },
		},
		{
			path: "/v/account/:id/merchandise",
			name: "AccountViewMerchandise",
			component: AccountViewMerchandise,
			meta: { title: `Merchandise | ${siteName}` },
		},
		{
			path: "/v/account/:id/merchandise/Create",
			name: "AccountViewMerchandiseCreate",
			component: AccountViewMerchandiseEdit,
			meta: { title: `New Merchandise Product | ${siteName}` },
		},
		{
			path: "/v/account/:id/merchandise/settings",
			name: "AccountViewMerchandiseSettings",
			component: AccountViewMerchandiseSettings,
			meta: { title: `Merchandise Settings | ${siteName}` },
		},
		{
			path: "/v/account/:id/merchandise/:productGuid",
			name: "AccountViewMerchandiseEdit",
			component: AccountViewMerchandiseEdit,
			meta: { title: `Edit Merchandise Product | ${siteName}` },
		},
		{
			path: "/v/account/:id/Imports/Bulk",
			name: "AccountImportsBulk",
			component: AccountImportsBulk,
			meta: { title: `Bulk Import | ${siteName}` },
		},
		{
			path: "/v/account/:id/EMailingList",
			name: "AccountEMailingList",
			component: AccountEMailingList,
			meta: { title: `Email Settings | ${siteName}` },
		},
		{
			path: "/v/account/:id/page-design",
			name: "DonationPageDesign",
			component: AccountDonationPageDesign,
			meta: { title: `Page Design | ${siteName}` },
		},
		{
			path: "/v/search",
			name: "SearchResults",
			component: SearchResults,
			meta: { title: `Search Results | ${siteName}` },
		},
		{
			path: "/v/example",
			name: "EinConfirmationLetterExample",
			component: EinConfirmationLetterExample,
			meta: { title: `EIN Confirmation Letter Example | ${siteName}` },
		},
		{
			path: "/v/super/home",
			name: "SuperAdminDashboard",
			component: SuperAdminDashboard,
			meta: {
				title: `Super Admin | ${siteName}`,
				isForSuperAdmin: true,
			},
		},
		{
			path: "/v/super/notifications",
			name: "SuperAdminNotifications",
			component: SuperAdminNotifications,
			meta: {
				title: `Super Admin Notifications | ${siteName}`,
				isForSuperAdmin: true,
			},
		},
		{
			path: "/v/super/attempts",
			name: "SuperAdminAttempts",
			component: SuperAdminAttempts,
			meta: {
				title: `Super Admin Attempts | ${siteName}`,
				isForSuperAdmin: true,
			},
		},
		{
			path: "/v/super/applications",
			name: "SuperAdminApplications",
			component: SuperAdminApplications,
			meta: {
				title: `Super Admin Applications | ${siteName}`,
				isForSuperAdmin: true,
			},
		},
		{
			path: "/v/super/invoices",
			name: "SuperAdminInvoices",
			component: SuperAdminInvoices,
			meta: {
				title: `Super Admin Invoices | ${siteName}`,
				isForSuperAdmin: true,
			},
		},
		{
			path: "/v/super/exports",
			name: "SuperAdminExports",
			component: SuperAdminExports,
			meta: {
				title: `Super Admin Exports | ${siteName}`,
				isForSuperAdmin: true,
			},
		},
		{
			path: "/v/super/users",
			name: "SuperAdminUsers",
			component: SuperAdminUsers,
			meta: {
				title: `Super Admin Users | ${siteName}`,
				isForSuperAdmin: true,
			},
		},
		{
			path: "/v/super/clients",
			name: "SuperAdminClients",
			component: SuperAdminClients,
			meta: {
				title: `Super Admin Clients | ${siteName}`,
				isForSuperAdmin: true,
			},
		},
		{
			path: '*',
			component: NotFound,
			name: 'NotFound',
			meta: { title: `Page Not Found | ${siteName}` },
		},
	],
};
